import { SITE } from "@/config/site";
import { Reveal } from "./Reveal";
import { Parallax, SplitWords } from "./Motion";

const chipColors = ["#0055FF", "#FF5500", "#84CC16", "#FF5566", "#8B5CF6", "#FACC15", "#0055FF", "#FF5500"];

export const About = () => (
  <section id="about" data-testid="about-section" className="relative scroll-mt-24 overflow-hidden bg-[#EFF6FF] py-20 sm:py-28">
    <Parallax speed={90} className="pointer-events-none absolute -left-16 top-10 h-56 w-56 rounded-full bg-[#0055FF]/10" />
    <Parallax speed={-70} className="pointer-events-none absolute bottom-0 right-[8%] h-32 w-32 rotate-12 rounded-[32px] bg-[#FF5566]/20" />
    <div className="container-x relative grid gap-14 lg:grid-cols-[1.2fr_1fr] lg:gap-20">
      <div>
        <h2 className="font-display text-4xl font-extrabold leading-[1.02] tracking-[-0.03em] text-slate-900 sm:text-5xl lg:text-6xl">
          <SplitWords text={SITE.about.title} />
        </h2>
        <Reveal delay={0.2} className="mt-8 space-y-4 text-base leading-relaxed text-slate-700 sm:text-lg">
          {SITE.about.body.map((t) => <p key={t}>{t}</p>)}
          {SITE.about.extra && <p>{SITE.about.extra}</p>}
        </Reveal>
      </div>
      <Reveal delay={0.1}>
        <div className="relative rounded-[32px] bg-white p-7 shadow-[0_20px_50px_rgba(0,85,255,0.12)] sm:p-9">
          <div className="anim-spin absolute -right-3 -top-3 h-14 w-14 rounded-2xl bg-[#FACC15]" style={{ animationDuration: "30s" }} aria-hidden="true" />
          <h3 className="font-display text-2xl font-extrabold text-slate-900">What we're good at</h3>
          <ul data-testid="about-skills" className="mt-6 flex flex-wrap gap-2.5">
            {SITE.skills.map((s, i) => (
              <li key={s} className="flex cursor-default items-center gap-2 rounded-full border border-slate-900/10 bg-[#FAF9F5] px-4 py-2 text-sm font-bold text-slate-800 transition-[transform,background-color,color] duration-300 hover:-translate-y-1 hover:bg-slate-900 hover:text-white">
                <span className="h-2 w-2 rounded-full" style={{ background: chipColors[i % chipColors.length] }} />{s}
              </li>
            ))}
          </ul>
        </div>
      </Reveal>
    </div>
  </section>
);
